// @flow
import {useQuery, keepPreviousData} from '@tanstack/react-query';
import type {UseQueryReturn} from '@tanstack/react-query';
import {programsAdmissionsList} from 'api/v2';
import type {
  PaginatedProgramAdmissionReadList,
  ProgramsAdmissionsListParams,
} from 'api/v2';

export const useProgramAdmissionsList = (
  params: ProgramsAdmissionsListParams,
): UseQueryReturn<PaginatedProgramAdmissionReadList, any> => {
  const query = useQuery({
    queryKey: ['programsAdmissionsList', params],
    queryFn: () => programsAdmissionsList(params),
    placeholderData: keepPreviousData,
    select: (response) => response.data,
  });

  return query;
};
